<script>
import { ArticleTag } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'ArticleTag List' }
    }
  },
  methods: {
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [this.getGeneralTab()]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Nazwa',
            modelPath: [this, 'form', 'name']
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return ArticleTag
    }
  }
}
</script>
